<template>
  <CCard>
    <!-- <div class="loader" v-if="isLoading">
      <CSpinner variant="grow" />
    </div>	 -->
    <CCardBody>
      <CDataTable
        :hover="hover"
        :striped="striped"
        :bordered="bordered"
        :small="small"
        :fixed="fixed"
        :items="items"
        :fields="fields"
        :items-per-page="small ? 10 : 5"
        :dark="dark"
        pagination
        tableFilter
        sorter		
        itemsPerPageSelect
      >
        <template #status="{item}">
          <td>
            <CBadge :color="getBadge(item.status)">{{item.status}}</CBadge>
          </td>		
        </template>
		  <template #action="{item}">
      <td>          
          <CButton color="primary" class="mr-2" :color="getEdit(item.action)" @click="edit(item.Request_ID,item.Date,item.ETA,item.Status,item.ManifestNo,item.SAP_VehicleNo)" :class="editcondition ? '':'hidden'">Edit</CButton>		
		  <!---<CButton color="info" class="px-4 mr-2" @click="view(item.Request_ID,item.Date,item.ETA)" >View</CButton>
          <CButton class="px-4" :color="getDelete(item.action)" @click="deletepop(item.Request_ID)">Delete</CButton> -->
        </td>
		  </template>
      </CDataTable>
	  <CModal
		  :show.sync="editModal"
		  :no-close-on-backdrop="true"
		  :centered="true"		  
		  size="sm"
		  color="dark"
		>
      <CRow>
		 <CCol sm="12" class="mb-3 editText">													
		  <label class="m-0 col-fonts-black editTextLine">Your</label>		 
		 </CCol>
		 <CCol sm="12" class="mb-3 statusOptions">													
		  <label class="m-0 col-fonts-black">Request Status</label>
		  <v-select :options="statusOptions"  placeholder="Select Status" @input="statusSel"></v-select>
		  </CCol>
		  <CCol sm="12" class="mb-3 reasonOptions">													
		  <label class="m-0 col-fonts-black">Reason for Update</label>
		  <v-select :options="reasonOptions" placeholder="Select Reason" @input="reasonSel" id="reasonOptions"></v-select>
		  </CCol>
		  <CCol sm="12" class="mb-3 PostPone_date">	
		  <CInput
              label="PostPone Date"
              type="date"  :value="currentdate" id="PostPone_date"
              />
		 </CCol>
		<CCol sm="12" class="mb-3">
			<label class="m-0 col-fonts-black">Manifest No: <strong class="">{{ManifestNo}}</strong></label>			
		</CCol>			
		<CCol sm="12" class="mb-3">
			<label class="m-0 col-fonts-black">Vehicle No: <strong class="">{{SAP_VehicleNo}}</strong></label>			
		</CCol>			
		<CCol sm="12" class="mb-3"> 
			<label class="m-0 col-fonts-black">Shipment Status: <strong class="">{{Shipment_status}}</strong></label>			
		</CCol>
		<CCol sm="12" class="mb-3">
			<label class="m-0 col-fonts-black">ETA: <strong class="">{{ResDateTime}}</strong></label>			
		</CCol>
		<CCol sm="12" class="mb-3">
			<label class="m-0 col-fonts-black">Latitude: <strong class="">{{Latitude}}</strong></label>			
		</CCol>
		<CCol sm="12" class="mb-3">
			<label class="m-0 col-fonts-black">Longitude: <strong class="">{{Longitude}}</strong></label>			
		</CCol>		
	  </CRow> 
      <template #footer>        
        <CCol sm="12 footer">
			<button aria-pressed="true" type="button" autocomplete="off" class="btn btn-outline-info btn-block active fw-500 col-white fs-18" @click="submit()">Submit</button>
		</CCol>
      </template>
    </CModal>
	
	  <CModal
      :show.sync="myModal"
      :no-close-on-backdrop="true"
      :centered="true"
      title="Delete"
      size="sm"
      color="dark"
    >
      Are you wan't to delete this?
      <template #header>
        <h6 class="modal-title">Delete</h6>
        <CButtonClose @click="myModal = false" class="text-white"/>
      </template>
      <template #footer>
        <CButton @click="myModal = false" color="danger">Cancel</CButton>
        <CButton @click="deleteRow" color="success">Delete</CButton>
      </template>
    </CModal>  
	 
    </CCardBody>
  </CCard>
</template>

<script>
import axios from "axios";
export default {
  name: 'Waste Request List',
  data () {
    return {
      myModal: false,
	  editModal:false,
      plantcodeOptions : [],
	  statusOptions:['PostPone','Cancel','Confirm'],
	  reasonOptions:[],
	  editcondition:"",
	  currentdate:'',
	  Postpone_Reason:[],
	  Cancel_Reason:[],
	  Request_Status:"",
	  reason:"",
	  ManifestNo:'',
	  SAP_VehicleNo:'',
	  Shipment_status:'',
	  ResDateTime:'',
	  Latitude:'',
	  Longitude:'',
	  isLoading: false
	  }
  },
  
  props: {
    items: Array,
    fields: {
      type: Array,
      default () {
        return ['Request_ID','Date','Customer_Name','Site_Name','Waste_Name','Quantity','Vehicle_Type','action']
      }
    },
    hover: Boolean,
    striped: Boolean,
    bordered: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean
  },
  mounted () {
	  this.isLoading = true;
		var self = this;
		var app_roleId=JSON.parse(localStorage.getItem("app_roleId"));
		if(app_roleId=='1'){		
			self.addcondition="1";		
		}else{
			var userRules=JSON.parse(localStorage.getItem("RoleWiseModules"));
			var modulefind = userRules.find(function(jsonitem, f){				
				if(jsonitem.Slug=='edit_waste_lifting'){
					self.editcondition="1";
				}		
			});		
		}
		
		 var today = new Date();		 
		  var date = today.getFullYear()+'-'+((today.getMonth()+1)< 10 ? '0'+(today.getMonth()+1) : (today.getMonth()+1))+'-'+(today.getDate()< 10 ? '0'+today.getDate() : today.getDate());
		  this.currentdate=date;
		  
		/* get waste request Reason*/		
		var requestInfo = {			  
		};
		var data = JSON.stringify(requestInfo);							
			var config = {
			  method: 'GET',
			  url: apiURL+'MasterData/GetRequestStatusReason',
			  headers: { 
				'Content-Type': 'application/json'
			  },
			  data : data
		};
		axios(config)
		.then((result) => {	
			this.isLoading = false;		
			if(result.data.status_code==200){
				var Postpone_ReasonArr=result.data.Postpone_Reason;
				var Postpone_Reason = [];
				var selArr = Postpone_ReasonArr.find(function(jsonitem, i){									
					Postpone_Reason.push(jsonitem.Postpone_Reason);								
				});
				this.Postpone_Reason=Postpone_Reason;
				this.reasonOptions=self.Postpone_Reason;	
				var Cancel_ReasonArr=result.data.Cancel_Reason;
				var Cancel_Reason=[];
				var selArr = Cancel_ReasonArr.find(function(jsonitem, i){									
					Cancel_Reason.push(jsonitem.Cancel_Reason);								
				});
				this.Cancel_Reason=Cancel_Reason;				
			}
		});
		
		//	get status
	var requestInfo = {
      RequestId: localStorage.getItem("waste_edit_id")      
	};
	var data = JSON.stringify(requestInfo);						
		var config = {
		  method: 'post',
		  url: apiURL+'MasterData/ShipmentStatusRequestStatus',
		  headers: { 
			'Content-Type': 'application/json'
		  },
		  data : data
	};
	this.isLoading = true;
	axios(config)
	.then((result) => {
		this.isLoading = false;
		this.Shipment_status=result.data.status;		
	})
	.catch((error) => {	
		this.isLoading = false;		  
		this.$swal.fire({
		  icon: 'error',
		  title: 'Oops...',
		  text: 'Something went wrong!'		 
		})
	});
	this.isLoading = true;
	//	get ETA
	var data = JSON.stringify(requestInfo);						
		var config = {
		  method: 'post',
		  url: apiURL+'MasterData/ShipmentETARequestStatus',
		  headers: { 
			'Content-Type': 'application/json'
		  },
		  data : data
	};
	axios(config)
	.then((result) => {
		this.isLoading = false;	
		this.ResDateTime=result.data.ResDateTime;		
	})
	.catch((error) => {	
		this.isLoading = false;		  
		this.$swal.fire({
		  icon: 'error',
		  title: 'Oops...',
		  text: 'Something went wrong!'		 
		})
	});	
	this.isLoading = true;
	//	get Lat Long
	var data = JSON.stringify(requestInfo);						
		var config = {
		  method: 'post',
		  url: apiURL+'MasterData/LatLongRequestStatus',
		  headers: { 
			'Content-Type': 'application/json'
		  },
		  data : data
	};
	axios(config)
	.then((result) => {
		this.isLoading = false;
		this.Latitude=result.data.Latitude;		
		this.Longitude=result.data.Longitude;				
	})
	.catch((error) => {	
		this.isLoading = false;		  
		this.$swal.fire({
		  icon: 'error',
		  title: 'Oops...',
		  text: 'Something went wrong!'		 
		})
	});
  },
  computed: {
        
   },
  methods: {
	edit(id,Date,ETA,Status,ManifestNo,SAP_VehicleNo){
		console.log('edit '+id+' '+Status);
		localStorage.setItem("waste_edit_id",id); 
		localStorage.setItem("Date",Date); 
		localStorage.setItem("ETA",ETA);

		this.ManifestNo=ManifestNo;
		this.SAP_VehicleNo=SAP_VehicleNo;
		
		if(Status=='Decline' || Status=='Confirm'){
			$('.statusOptions').hide();
			$('.reasonOptions').hide();
			$('.PostPone_date').hide();
			$('.footer').hide();
			if(Status=='Decline'){
			$('.editTextLine').html('This order is already canceled.');			
			}else{
			$('.editTextLine').html('This order is already Confirmed.');			
			}
			$('.editText').show();			
		}else{
			$('.statusOptions').show();
			$('.reasonOptions').show();
			$('.PostPone_date').show();
			$('.footer').show();
			$('.editText').hide();
		}
		this.editModal= true;
		//this.$router.push({path:'edit_waste_lifting'})
	},
	statusSel(value){
		var self = this;
		console.log(value);
		if(value=='Cancel'){
			self.reasonOptions=self.Cancel_Reason;	
			self.Request_Status=value;
			$('.PostPone_date').hide();			
		}else if(value=='Confirm'){
			$('.reasonOptions').hide();
			$('.PostPone_date').hide();
			self.Request_Status=value;			
		}else{
			self.reasonOptions=self.Postpone_Reason;	
			$('.reasonOptions').show();
			$('.PostPone_date').show();	
			self.Request_Status=value;
		}
	},
	reasonSel(value){
		var self = this;
		self.reason=value;
	},
	submit(){
		this.isLoading = true;
		var self = this;
		var Item_Id=localStorage.getItem("waste_view_id");
		var Token=localStorage.getItem("auth");
		var Session_User_Id=JSON.parse(localStorage.getItem("User_Id"));
		var Req_Status = self.Request_Status;
		var Item_Id=localStorage.getItem("waste_view_id");
		var Req_Date=localStorage.getItem("Date");
		var Req_Tim=localStorage.getItem("ETA");
		var reason = self.reason;
		//console.log(reason);
		var Postpone_Remark="";
		var Cancel_Remark="";
		var Req_Cancel_Date="";
		var Req_Confirm_Date="";
		if(Req_Status=='Cancel'){
			Cancel_Remark=reason;
			Req_Cancel_Date=self.currentdate;
		}else if(Req_Status=='Confirm'){
			Req_Confirm_Date=self.currentdate;
		}else if(Req_Status=='PostPone'){
			Postpone_Remark=reason;
		}else{
			
		}
		var requestInfo = {
			Item_Id:Item_Id,
			Emp_Id:Session_User_Id,
			Req_Date:Req_Date,
			Req_Tim:Req_Tim,
			Req_Status:Req_Status,
			Postpone_Remark:Postpone_Remark,
			Cancel_Remark:Cancel_Remark,
			Req_Cancel_Date:Req_Cancel_Date,
			Req_Confirm_Date:Req_Confirm_Date,
			Token:Token,
			Session_User_Id:Session_User_Id,
		};
		//console.log(requestInfo);
		//return false;
		var data = JSON.stringify(requestInfo);							
			var config = {
			  method: 'post',
			  url: apiURL+'MasterData/UpdateWasteRequestStatus',
			  headers: { 
				'Content-Type': 'application/json'
			  },
			  data : data
		};
		axios(config)
		.then((result) => {		
			this.isLoading = false;	
			if(result.data.status_code==200){
				if(result.data.status_code==200){
					var obj=result.data.response;
					this.$swal.fire({
						icon: 'success',
						title: 'Edit',
						text: 'Data edit successfully..'		 
					  })
				}else{
					this.$swal.fire({
						icon: 'error',
						title: 'Oops...',
						text: 'Something went wrong!'		 
					  })
				}						
			}
			self.editModal=false;
		})
		.catch((error) => {	
		  this.isLoading = false			
          this.$swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Something went wrong!'		 
          })
        });		
	},
	view(id){ 
		localStorage.setItem("waste_view_id",id); 		
		this.$router.push({path:'viewWasteRequest'})
	}
	,
	getEdit (color) {
      return 'primary';
    },
	getDelete(color){
		return 'danger';
	},	
	deletepop(id){
		$("#del").attr("rowData",id);
		this.myModal= true;
		//alert('call'+id);
	},
	deleteRow(){
		var id=$("#del").attr("rowData");
		console.log('delete '+id);		
		this.myModal= false;		
	},
	add(){
		console.log('add');
		this.$router.push({path:'add_waste'})
	}
  }
}
</script>
